export const data = [];

// 顶部step
export const topSteps = [
  {
    title: '填写流程信息',
    index: 0,
  },
  {
    title: '配置流程节点',
    index: 1,
  },
  {
    title: '全局配置',
    index: 2,
  },
  {
    title: '完成',
    index: 3,
  },
];
// 配置节点时step
export const processStep = [
  {
    title: '创建订单',
    index: 0,
    code: 'CREATE_ORDER',
  },
  {
    title: '接单',
    index: 1,
    code: 'DEAL',
  },
  {
    title: '计费',
    index: 2,
    code: 'PRICING',
  },
  {
    title: '授信',
    index: 3,
    disable: true,
  },
  {
    title: '转派',
    index: 4,
    // disable: true,
  },
  {
    title: '派车',
    index: 5,
    code: 'DISPATCH',
    // disable: true,
  },
  {
    title: '司机接单',
    index: 6,
    code: 'DRIVER_DEAL',
    // disable: true,
  },
  {
    title: '装载',
    index: 7,
    // disable: true,
  },
  {
    title: '签收',
    index: 8,
    disable: true,
  },
];

// 流程完成阶段
export const processModuleCode = ['CREATE_ORDER', 'DEAL', 'PRICING', 'GLOBAL'];

// 特殊展示模块
export const specialModule = {
  CREATE_ORDER: ['SKU_WEIGHT_RANGE', 'SKU_VOLUME_RANGE', 'SKU_SUM_RANGE', 'SKU_WEIGHT_VOLUME_RATIO', 'CREATE_START_TIME', 'MAKEUP_START_TIME', 'CREATE_REACH_TIME', 'MAKEUP_REACH_TIME', 'PRICING_QUOTA'],
  DEAL: [],
  PRICING: ['PRICING_QUOTA'],
  DISPATCH: [],
  // TODO:
  DRIVER_DEAL: [],
};

// 仓储流程配置相关
// 配置节点时step
export const processStepWareHouse = [
  {
    title: '创建订单',
    index: 0,
    code: 'CREATE_ORDER',
  },
  {
    title: '接单',
    index: 1,
    code: 'DEAL',
  },
  {
    title: '转派',
    index: 2,
  },
];
